module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-33.4c10fe6b.png";